import { useContext } from "react";
import { StepperContext } from "./StepperProvider";

export const useStepper = () => useContext(StepperContext);
